<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="card">
          <div class="card-body">
            <p>Receipt identifier:</p>
            <h2>{{ receiptSlug }}</h2>

            <hr />
            <receipt-details-lookup :receipt-slug="receiptSlug">
            </receipt-details-lookup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptDetailsLookup from "@/components/ReceiptDetailsLookup";

export default {
  name: "receiptSearch",
  props: ["receiptSlug"],
  components: {
    ReceiptDetailsLookup
  }
};
</script>
